export default "__VITE_ASSET__BKYVqjBx__"